export default __webpack_public_path__ + "static/media/filters.99061e6d.webm";